module.exports = __webpack_public_path__ + "static/media/mq.f9360e7b.svg";